export default __webpack_public_path__ + "static/media/sh2_8.1d5b6f3f.jpg";